var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginComponent',{attrs:{"placeholder":'0123456789123',"mode":'numeric',"test-pins":['2102970103257', '1507987175029'],"initial-pin":_vm.pin}})}
var staticRenderFns = []

export { render, staticRenderFns }